import { Link } from 'react-router-dom';
import { LegalPage } from './LegalPage';
import { LEGAL_CONTACT, LEGAL_VERSIONS } from '@makhe/shared';

export default function CommunityGuidelinesPage() {
  return (
    <LegalPage title="Community Guidelines" lastUpdated={LEGAL_VERSIONS.communityGuidelines}>
      <p>
        Makhe is by students, for students. These guidelines keep the community safe and
        trustworthy. They supplement our <Link to="/legal/terms">Terms of Service</Link>.
      </p>

      <h2>Be respectful</h2>
      <p>
        Treat other students with dignity. No harassment, discrimination, threats, or unwanted
        contact outside the booking context.
      </p>

      <h2>Meet safely</h2>
      <ul>
        <li>Prefer shared campus spots or well-lit public areas for first meetings.</li>
        <li>Tell a friend where you are going and when you expect to finish.</li>
        <li>Use the safety panel on active bookings for emergency numbers.</li>
        <li>Off-campus private residences may be outside campus security coverage.</li>
      </ul>

      <h2>Honest listings</h2>
      <p>
        Show real results in your videos and photos. Do not bait-and-switch pricing or misrepresent
        your skills.
      </p>

      <h2>Keep payments on Makhe</h2>
      <p>
        Do not ask buyers to pay off-platform. Off-platform payments void escrow protection and
        may result in account suspension.
      </p>

      <h2>Report problems</h2>
      <p>
        Use the in-app report button for harassment, safety concerns, fraud, or inappropriate
        content. For emergencies, contact SAPS (10111) or campus security first, then report on
        Makhe.
      </p>

      <h2>Consequences</h2>
      <p>
        Violations may lead to warnings, suspension, or permanent removal. Serious offences may be
        referred to your institution or law enforcement.
      </p>

      <p>
        Questions: <a href={`mailto:${LEGAL_CONTACT.email}`}>{LEGAL_CONTACT.email}</a>
      </p>
    </LegalPage>
  );
}
